import { gql } from "@apollo/client";

export const FETCH_STOCK_SUPPLIERS = gql`
  query FETCH_STOCK_SUPPLIERS {
    suppliers(forChinaStock: true, withRanking: true) {
      id
      name
    }
    products(forChinaStock: true) {
      results {
        id
        number
        name
        wisStocks {
          id
        }
        defaultSupplier {
          id
          name
        }
        stockSuppliers {
          id
          name
        }
      }
    }
  }
`;

export const FETCH_SUPPLIER_CHINA_STOCK_PRODUCTS = gql`
  query FETCH_CHINA_STOCK_PRODUCTS($supplierId: ID!) {
    supplier: factory(id: $supplierId) {
      id
      nickName
    }
    products(forChinaStockSupplierId: $supplierId) {
      results {
        id
        odooId
        number
        name
        company
        nameCn
      }
    }
  }
`;

export const FETCH_STOCK_SUPPLIER_OVERVIEW = gql`
  query FETCH_STOCK_SUPPLIER_OVERVIEW($supplierId: ID!) {
    stockSupplierOverview(supplierId: $supplierId)
  }
`;

export const FETCH_CHINA_V2_PRODUCT = gql`
  query FETCH_CHINA_V2_PRODUCT($supplierId: ID!, $productId: ID!) {
    supplier: factory(id: $supplierId) {
      id
      name
    }
    product(id: $productId) {
      id
      number
      name
    }
  }
`;

export const FETCH_CHINA_V2_PRODUCT_STOCKS = gql`
  query FETCH_CHINA_V2_PRODUCT_STOCKS($productId: ID!, $supplierId: ID!) {
    stockSupplierProductHistory(
      productId: $productId
      supplierId: $supplierId
      includeNotConfirmedPlans: true
    )
  }
`;
